import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";
import usePageMeta from "../lib/usePageMeta";

export default function CurrentlyAvailable() {
  usePageMeta("Currently Available — UK Stock", "Research-use-only peptides currently held in Peptigen Labs UK stock.");
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data.filter((p) => p.stock_status !== "out_of_stock"))).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="currently-available-page">
      <div className="mb-12">
        <div className="pg-micro mb-3">// Currently Available</div>
        <h1 className="text-[#F7FAFC] text-4xl lg:text-5xl pg-display" style={{ fontFamily: "'Exo 2'" }}>
          UK Stock — Available Now
        </h1>
        <p className="text-[#9CA8B8] mt-3 max-w-2xl">
          Research-use-only peptides currently held in Peptigen Labs UK stock. Order before 14:00
          on a working day for same-day UK dispatch.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {products.map((p) => (
          <ProductCard key={p.sku} product={p} featured />
        ))}
      </div>

      {products.length === 0 && (
        <div className="text-center py-16 text-[#9CA8B8]">
          Stock is currently being replenished. Check back shortly.
        </div>
      )}

      <div className="mt-16 text-center">
        <Link to="/products" className="pg-btn-ghost" data-testid="see-full-catalogue">
          See full research catalogue <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
